import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DealerProfile } from '@app/domain/model/dealer-profile';

@Component({
  templateUrl: './admin-dealer-report-log.component.html',
  styleUrls: ['./admin-dealer-report-log.component.scss']
})
export class AdminDealerReportLogComponent implements OnInit {

  profile: DealerProfile;

  constructor(private route: ActivatedRoute, private readonly router: Router) {
  }

  ngOnInit() {
    this.route.parent.data.subscribe((data) => {
      this.profile = data.profile;
      if(this.profile.bulkDataReport) {
        this.router.navigate([`/admin/dealer/${this.profile.id}/report-search`]);
      }
    });
  }


}
